import React, { useEffect, useState } from "react";
import "./SysGuard.scss";
import NoDataAvailablePage from "./OnBoarding/NoDataAvailablePage";
import {
  ENTRA,
  GET_DATASOURCE,
  GOOGLEWORKSPACE,
  MICROSOFTAD,
} from "../../redux/constants/constants";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, isNull } from "lodash";
import {
  FETCH_ALL_SYS_GUARD_DATA_SOURCES,
  statusMapping,
  SET_EDITING_DATASOURCE_ID,
} from "./sysGuardConstants";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import SysGuardIncognito from "./SysGuardIncognito";
import TimeSelector from "./Dashboard/Components/TimeSelector";
import {
  getClassNamesByType,
  useSysGuardDataSource,
} from "./SysGuardCommonComp";
import { Button } from "@material-ui/core";
import DataSourceSelector from "./DataSourceSelector";

const SysGuard = ({ source }) => {
  const currentRoute = useLocation();
  const dispatch = useDispatch();
  const dataSourceData = useSysGuardDataSource();
  const [isEditMode, setIsEditMode] = useState(false);
  const [openOnBoardingForm, setOpenOnBoardingForm] = useState(false);
  const loader = useSelector((state) => state.SysGuardReducer.loader);
  const dataSourcesById = useSelector(
    (state) => state.SysGuardReducer.sysGuardDataSource
  );
  const { iconClassName, containerClassName, title } = getClassNamesByType(
    dataSourceData?.type?.code
  );

  useEffect(() => {
    if (currentRoute.search !== "") {
      const urlParam = new URLSearchParams(currentRoute.search);
      const stateParam = urlParam.get("state");
      const code = urlParam.get("code");
      let dropBoxData = {
        code: code,
      };

      if (stateParam && code) {
        const state = stateParam.includes("_")
          ? stateParam.split("_")
          : [stateParam, null];
        let dataSourceID = state[0];
        let consentType = state[1] || null;
        if (consentType) {
          dispatch({
            type: GET_DATASOURCE,
            payload: {
              dataSourceID,
              consentType,
            },
          });
        } else {
          dispatch({
            type: GET_DATASOURCE,
            payload: {
              dataSourceID,
              consentType,
              dropBoxData,
            },
          });
        }
      }
    }
    // Fetch all SysGuard data sources in a single API call
    dispatch({ type: FETCH_ALL_SYS_GUARD_DATA_SOURCES });
  }, []);

  return (
    <div className="sys-guard">
      {loader && (
        <img src={Page_Loader} alt="loading" className="sysGuardLoader"></img>
      )}
      <div className="createRRHeader sysGuard">
        <div className="riskGovernanceHeaderContainer">
          <div>
            <h2 className="sysGuardHeaderTitle">SysGuard Dashboard</h2>
          </div>
          {!isEmpty(dataSourcesById) &&
            !isNull(dataSourcesById) ? (
            <div className="sys-guard-connection-status-container">
              <TimeSelector type={dataSourceData?.type?.code} />
              <DataSourceSelector 
                setIsEditMode={setIsEditMode}
                setOpenOnBoardingForm={setOpenOnBoardingForm}
              />
              <Button
                className="createSysGuardButton"
                onClick={() => {
                  dispatch({ type: SET_EDITING_DATASOURCE_ID, payload: null });
                  setOpenOnBoardingForm(true);
                }}
              >
                Add
              </Button>
              <SysGuardIncognito />
            </div>
          ) : null}
        </div>
      </div>
      <NoDataAvailablePage
        source={source}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        openOnBoardingForm={openOnBoardingForm}
        setOpenOnBoardingForm={setOpenOnBoardingForm}
      />
    </div>
  );
};

export default SysGuard;
